<template>
  <div class="wrap cart-wrap flex-column">
    <mu-infinite-scroll
      :loading="load"
      loadingText="拼命加载中"
      class="load"
      v-if="load"
    />
    <emptyCart
      imgpath="/static/images/empty_shopping_cart_3x.png"
      emptytext="购物车空啦"
      btntext="逛一逛"
      btnurl="/main/home"
      v-show="cartInfoList.length == 0 && !load"
    ></emptyCart>
    <div class="grid-tip" v-if="cartInfoList.length > 0 && !load">
      购物车({{ totalGoodsNum }})
      <p @click="isEdit = true" v-show="!isEdit" class="fr">编辑</p>
      <p @click="isEdit = false" v-show="isEdit" class="fr">完成</p>
    </div>
    <div class="flex-item cart-box" v-if="!load">
      <div class="cart-list">
        <div class="cart-item" v-for="(storeItem, storeIndex) in cartInfoList">
          <!-- 品牌 -->
          <div class="brandTitle">
            <mu-checkbox
              name="group"
              v-model="storeItem.Selected"
              @change="storeAll($event, storeIndex)"
              class="list-radio floatL"
            />
            <span @click="gotoBrandHome(storeItem.storeId)">
              <!-- <img class="logo floatL" src="/static/images/mexin_logo_3x.png"> -->
              <imgs
                :width="120"
                :imagePath="
                  storeItem &&
                  storeItem.storeLogoPath &&
                  storeItem.storeLogoPath.imagePath
                "
                class="logo floatL"
              ></imgs>
              <p><label>品牌：</label>{{ storeItem && storeItem.storeName }}</p>
              <img class="user-right" src="/static/images/ic_more_3x.png" />
            </span>
            <span
              class="getcoupon"
              @click="
                couponPopup = true;
                getListStoreCoupon(storeItem.storeId);
              "
              >领券</span
            >
            <div class="clearfix"></div>
          </div>
          <template v-for="(goodsItem, goodsIndex) in storeItem.cartGoodses">
            <!-- DIY 产品信息 -->
            <div class="cartTitle" v-if="goodsItem.sourceType == 2">
              <mu-list>
                <touchDelete
                  :key="goodsIndex"
                  :index="goodsItem.instSkuId"
                  @deleteItem="deleteItem"
                >
                  <mu-list-item :title="goodsItem.goodsName">
                    <mu-checkbox
                      name="group"
                      v-model="goodsItem.cartSelected"
                      class="list-radio"
                      @change="changeSelect($event, storeIndex, goodsIndex)"
                    />
                    <div class="listItem" v-if="!isEdit">
                      <p class="price">￥{{ goodsItem.salePrice }}</p>
                      <p class="count">x{{ goodsItem.goodsNum }}</p>
                      <div class="clearfix"></div>
                    </div>
                    <div class="listItem edit" v-if="isEdit">
                      <span
                        class="reduce-btn"
                        @click="
                          changeNum(
                            'add',
                            goodsItem.instSkuId,
                            goodsItem.goodsNum
                          )
                        "
                      ></span>
                      <span class="input">{{ goodsItem.goodsNum }}</span>
                      <span
                        class="add-btn"
                        @click="
                          changeNum(
                            'reduce',
                            goodsItem.instSkuId,
                            goodsItem.goodsNum
                          )
                        "
                      ></span>
                      <div class="clearfix"></div>
                    </div>
                  </mu-list-item>
                </touchDelete>
              </mu-list>
              <div
                class="dashLine dashLineparent"
                v-if="goodsItem.sourceType == 2 && !isEdit"
              ></div>
            </div>
            <!-- 子产品列表 -->
            <mu-list
              v-bind:class="[isEdit ? 'isedit' : '']"
              v-if="
                goodsItem.sourceType == 2 &&
                goodsItem.subCartGoods &&
                goodsItem.subCartGoods.length > 0
              "
            >
              <touchDelete
                v-for="(subItem, subIndex) in goodsItem.subCartGoods"
                :key="subIndex"
                :index="subItem.instSkuId"
                @deleteItem="deleteItem"
              >
                <!-- hr  非DIY的第一条不显示  =>  DIY || 非DIY的第二条以后-->
                <hr
                  v-if="
                    (subIndex > 0 && subItem.sourceType == 1) ||
                    subItem.sourceType == 2
                  "
                />
                <mu-list-item :title="subItem.goodsName">
                  <mu-checkbox
                    name="group"
                    v-model="goodsItem.cartSelected"
                    class="list-radio"
                    @change="changeSelect($event, storeIndex, subIndex)"
                    v-if="goodsItem.sourceType == 1 || isEdit"
                  />
                  <div
                    @click="
                      gotoDetail(
                        storeItem.storeId,
                        subItem.goodsId,
                        subItem.skuId
                      )
                    "
                    slot="leftAvatar"
                    class="leftAvataDiv"
                  >
                    <imgs
                      :width="200"
                      :height="200"
                      :imagePath="subItem.imagePath.imagePath"
                    ></imgs>
                  </div>
                  <!-- <imgs :imagePath="subItem.imagePath.imagePath" slot="leftAvatar"  @click="gotoDetail(storeItem.storeId,subItem.goodsId,subItem.skuId)"></imgs> -->
                  <!-- 非编辑状态显示价格数量 -->
                  <div class="listItem" v-if="!isEdit">
                    <p class="price">
                      ￥{{ goodsItem.salePrice
                      }}<label>￥{{ goodsItem.unitPrice }}</label>
                    </p>

                    <p class="count">x{{ goodsItem.goodsNum }}</p>
                    <div class="clearfix"></div>
                  </div>
                  <!-- 暂时不显示 -->
                  <!-- <p class="arrow-expand"  v-if="isEdit" @click="headimgPopup = true"></p> -->
                  <!--  DIY 产品  非编辑状态   显示左侧线条  -->
                  <div v-if="goodsItem.sourceType == 2 && !isEdit">
                    <div
                      class="dashLine dashLineall"
                      v-if="subIndex != goodsItem.subCartGoods.length - 1"
                    ></div>
                    <div
                      class="dashLine dashLinetop"
                      v-if="subIndex == goodsItem.subCartGoods.length - 1"
                    ></div>
                    <div class="pointp"></div>
                  </div>
                </mu-list-item>
              </touchDelete>
            </mu-list>
            <!-- 产品列表 -->
            <mu-list
              v-bind:class="[isEdit ? 'isedit' : '']"
              v-if="goodsItem.sourceType == 1"
            >
              <touchDelete
                @deleteItem="deleteItem"
                :index="goodsItem.instSkuId"
              >
                <!-- hr  非DIY的第一条不显示  =>  DIY || 非DIY的第二条以后-->
                <hr
                  v-if="
                    (goodsIndex > 0 && goodsItem.sourceType == 1) ||
                    goodsItem.sourceType == 2
                  "
                />
                <mu-list-item :title="goodsItem.goodsName">
                  <!--  DIY 产品不显示复选框 -->
                  <mu-checkbox
                    name="group"
                    v-model="goodsItem.cartSelected"
                    class="list-radio"
                    @change="changeSelect($event, storeIndex, goodsIndex)"
                    v-if="goodsItem.sourceType == 1 || isEdit"
                  />
                  <div
                    @click="
                      gotoDetail(
                        storeItem.storeId,
                        goodsItem.goodsId,
                        goodsItem.skuId
                      )
                    "
                    slot="leftAvatar"
                    class="leftAvataDiv"
                  >
                    <imgs
                      :width="200"
                      :height="200"
                      :imagePath="goodsItem.imagePath.imagePath"
                    ></imgs>
                  </div>
                  <!-- 编辑状态  非DIY 显示加减 -->
                  <div class="listItem edit" v-if="isEdit">
                    <span
                      class="reduce-btn"
                      @click="
                        changeNum(
                          'add',
                          goodsItem.instSkuId,
                          goodsItem.goodsNum
                        )
                      "
                    ></span>
                    <span class="input">{{ goodsItem.goodsNum }}</span>
                    <span
                      class="add-btn"
                      @click="
                        changeNum(
                          'reduce',
                          goodsItem.instSkuId,
                          goodsItem.goodsNum
                        )
                      "
                    ></span>
                    <div class="clearfix"></div>
                  </div>
                  <!-- <span class="mu-item-text-my">{{goodsItem.goodsNum}}</span> -->
                  <!-- <span slot="describe" v-if="!isEdit">{{cartitem.describe}}</span> -->
                  <!-- 非编辑状态显示价格数量 -->
                  <div class="listItem" v-if="!isEdit">
                    <p class="price">
                      ￥{{ goodsItem.salePrice
                      }}<label>￥{{ goodsItem.unitPrice }}</label>
                    </p>
                    <p class="count">x{{ goodsItem.goodsNum }}</p>
                    <div class="clearfix"></div>
                  </div>
                  <!-- <p class="arrow-expand"  v-if="isEdit" @click="headimgPopup = true"></p> -->
                </mu-list-item>
              </touchDelete>
            </mu-list>
          </template>
        </div>
      </div>
      <!-- <mu-infinite-scroll class="myscroll" :scroller="scroller" :loading="loading" loadingText="" @load="loadMore" v-if="hasdata"/> -->
      <!-- <p v-if="!hasdata" class="bottom-nodata">已经到底了，没有数据啦☹</p> -->
    </div>
    <div class="cartBottom" v-if="cartInfoList.length > 0 && !isEdit && !load">
      <mu-checkbox
        name="group"
        id="all"
        v-model="all"
        class="list-radio"
        @change="handleCheckAllChange($event)"
        label="全选"
      />
      <p class="count ellipsis pdl">
        合计：<span>￥{{ totalGoodsPrice }}</span
        ><span>(不含运费)</span>
      </p>
      <div
        class="go"
        @click="goOrderPay"
        v-bind:class="[totalGoodsPrice <= 0 ? 'disabledbtn' : 'primarybtn']"
      >
        去结算
      </div>
    </div>
    <div class="cartBottom" v-if="cartInfoList.length > 0 && isEdit && !load">
      <mu-checkbox
        name="group"
        id="all"
        v-model="all"
        class="list-radio"
        @change="handleCheckAllChange($event)"
        label="全选"
      />
      <div
        class="go"
        @click="isDeletes = true"
        v-bind:class="[totalGoodsPrice < 0 ? 'disabledbtn' : 'primarybtn']"
      >
        删除
      </div>
      <div
        class="go"
        @click="addCollect"
        v-bind:class="[totalGoodsPrice < 0 ? 'disabledbtn' : 'orangebtn']"
      >
        加入收藏夹
      </div>
    </div>
    <menus></menus>
    <!-- 立即购买或者加入购物车 -->
    <mu-popup
      position="bottom"
      popupClass="custom-popup-bottom flex-column"
      :open="headimgPopup"
      @close="headimgPopup = false"
    >
      <div class="flex-item">
        <div class="goods-detail">
          <div class="close-button" @click="headimgPopup = false"></div>
          <div class="goods-img">
            <imgs :imagePath="require('@assets/zyImages/u276.jpeg')"></imgs>
          </div>
          <div class="goods-desc">
            <p class="price"><samp>¥</samp>6502</p>
            <p class="desc overflowT2">
              Mexin美心家美实木复合 简欧免漆室内套装卧室门简欧免漆室内套装卧室门
              木门包安装 N856
            </p>
          </div>
        </div>
        <div class="goods-label">
          <p class="title">颜色</p>
          <div class="label-list">
            <span
              class="label"
              v-for="i in 5"
              @click="id = i"
              :class="{ active: id == i }"
              >实色浪漫白</span
            >
          </div>
        </div>
        <div class="goods-number">
          <p class="title">数量</p>
          <span class="reduce-btn" @click="goodsNum('reduce')"></span>
          <input v-model="goodsNumber" readonly />
          <span class="add-btn" @click="goodsNum('add')"></span>
          <samp>件</samp>
        </div>
      </div>
      <div class="bottom-button">
        <mu-raised-button label="确定" class="fullButton" primary />
      </div>
    </mu-popup>
    <!-- 单个删除 -->
    <mu-dialog
      :open="isDelete"
      title="删除商品"
      titleClass="dialogTitle"
      bodyClass="dialogBody"
      actionsContainerClass="dialogActionsContainer"
      @close="isDelete = false"
    >
      确定删除这个商品？
      <mu-flat-button
        slot="actions"
        @click="isDelete = false"
        primary
        label="否"
      />
      <mu-flat-button slot="actions" primary label="确定" @click="removeCart" />
    </mu-dialog>
    <!-- 批量删除 -->
    <mu-dialog
      :open="isDeletes"
      title="删除商品"
      titleClass="dialogTitle"
      bodyClass="dialogBody"
      actionsContainerClass="dialogActionsContainer"
      @close="isDeletes = false"
    >
      您确定删除已勾选的商品？
      <mu-flat-button
        slot="actions"
        @click="isDeletes = false"
        primary
        label="否"
      />
      <mu-flat-button
        slot="actions"
        primary
        label="确定"
        @click="removeCarts"
      />
    </mu-dialog>
    <!-- 领取优惠券 -->
    <mu-popup
      position="bottom"
      popupClass="coupon-receive-popup-bottom flex-column"
      :open="couponPopup"
      @close="couponPopup = false"
    >
      <div class="flex-item">
        <div class="goods-detail">
          <div class="close-button" @click="couponPopup = false"></div>
          <div class="coupon-box">
            <div class="coupon-list">
              <div class="coupon-list-item title">
                领券
              </div>
              <!-- <p v-show="couponsList.length == 0 ">当前店铺没有优惠券了~</p> -->
              <emptyCart
                emptytext="当前店铺没有优惠券了~"
                v-show="couponsList.length == 0"
              ></emptyCart>
              <table class="coupon-list-item">
                <tr v-for="couponItem in couponsList">
                  <td>
                    <!-- <div class="redpackage">￥{{couponItem.couponAmount}}</div> -->
                    <div
                      :class="{
                        coupon: couponItem.couponType == 1,
                        redpackage: couponItem.couponType == 2,
                      }"
                      v-if="couponItem.couponCate != 3"
                    >
                      ￥{{ couponItem.couponAmount }}
                    </div>
                    <div
                      :class="{
                        coupon: couponItem.couponType == 1,
                        redpackage: couponItem.couponType == 2,
                      }"
                      v-if="couponItem.couponCate == 3"
                    >
                      {{ couponItem.couponDiscount | discount }}<samp>折</samp>
                    </div>
                  </td>
                  <td>
                    <p v-if="couponItem.couponType == 1">
                      {{
                        couponItem.useAmount == 0
                          ? "不限制"
                          : "满" + couponItem.useAmount + "可用"
                      }}
                    </p>
                    <p v-if="couponItem.couponType == 2">
                      剩余{{(parseInt(couponItem.sendNum)-parseInt(couponItem.recivedNum))



                      }}个红包
                    </p>
                    <!-- <p v-if="couponItem.couponType==2">{{couponItem.sendNum - couponItem.recivedNum == 0 ? '红包被领完啦' : '剩余'+couponItem.sendNum - couponItem.recivedNum+'个红包'}}</p> -->
                    <label
                      >{{ couponItem.effectiveTime }} -
                      {{ couponItem.overdueTime }}</label
                    >
                  </td>
                  <td>
                    <button
                      type="default"
                      class="gray finish"
                      disabled
                      v-if="couponItem.isGet == 1"
                    >
                      已领取
                    </button>
                    <button
                      type="default"
                      class="gray"
                      v-if="couponItem.isGet == 0"
                      @click="
                        getCoupon(
                          couponItem.couponId,
                          couponItem.couponType,
                          couponItem.isGet
                        )
                      "
                    >
                      领取
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-button">
        <mu-raised-button
          label="确定"
          class="fullButton"
          primary
          @click="couponPopup = false"
        />
      </div>
    </mu-popup>
    <mu-toast
      v-if="toast.toast"
      :message="toast.messageTip"
      class="custom-toast"
    />
  </div>
</template>
<script type="text/javascript">
import touchDelete from "@components/touchDelete/touchDelete";
import menus from "@components/menus/menus";
import emptyCart from "@components/empty/empty";
import imgs from "@components/image/image";
import { storage } from "@common/utils/util.js";
import { mapGetters, mapActions } from "Vuex";
export default {
  data() {
    return {
      load: true,
      all: false,
      headimgPopup: false,
      id: "",
      isEdit: false, //编辑状态
      isDelete: false, //单个删除弹框
      isDeletes: false, //批量删除弹框
      cartInfoList: [], //购物车商品列表
      totalGoodsPrice: 0, //总价
      totalGoodsNum: 0, //购物车商品数量
      goodsNumber: 0,
      settleDatas: [], //结算店铺列表
      OrderSettleMsg: {}, //订单信息
      couponAmounts: [], //选中的优惠券
      redpacketAmounts: [], //选中的优惠券
      deleteid: null,
      toast: {
        toast: false,
        messageTip: "",
      },
      //以下为优惠券
      couponPopup: false, //优惠券弹框
      couponsList: [], //优惠券列表
      tempStoreId: "", //店铺id
    };
  },
  watch: {
    //深度 watcher
  },
  created() {
    this.cartInfo();
  },
  methods: {
    ...mapActions({
      getOrderSettleMsgFromCart: "getOrderSettleMsgFromCart", //购物车结算
      getCartGoodsNum: "getCartGoodsNum", //获取购物车商品数量
      getListStoreCoupons: "getListStoreCoupons", //获取优惠券列表
      receiveCoupon: "receiveCoupon", //领取优惠券
    }),
    showTipMessage(isShow, msg) {
      this.toast.toast = isShow;
      this.toast.messageTip = msg;
      setTimeout(() => {
        this.toast.toast = false;
      }, 1500);
    },
    //获取优惠券列表
    getListStoreCoupon(storeId) {
      this.tempStoreId = storeId;
      this.getListStoreCoupons(storeId).then((res) => {
        this.couponsList = res;
      });
    },
    //领取优惠券
    getCoupon(couponId, couponType, isGet) {
      if (isGet == 1) {
        return;
      }
      this.receiveCoupon([couponId, couponType])
        .then((res) => {
          if (res.success) {
            this.showTipMessage(true, res.message || "领取成功！");
            this.getListStoreCoupon(this.tempStoreId);
          } else {
            this.showTipMessage(true, res.message || "领取失败，请稍后重试！");
          }
        })
        .catch((error) => {
          this.showTipMessage(true, error);
        });
    },
    gotoBrandHome(storeid) {
      this.$router.push({
        path: "/main/brandHome?linkTarget=" + storeid + "&linkType=2",
      });
    },
    gotoDetail(storeid, goodid, skuId) {
      this.$router.push({
        path:
          "/main/goodsDetail?goodsId=" +
          goodid +
          "&storeId=" +
          storeid +
          "&skuId=" +
          skuId,
      });
    },
    cartInfo() {
      this.getCartNum();
      let _this = this;
      //this.cartInfoList = [];
      this.api.cartHandler.getCartInfo([], (res) => {
        let data = res.target.target;
        this.load = false;
        if (data != null) {
          //判断store是否勾选
          let storenum = 0; //选中的店铺数量
          data.cartGoodsItems.forEach((item) => {
            //  _this.getListStoreCoupons(item.storeId).then(res =>{
            //    item.couponsList = res;
            // })
            let count = 0; //计数器
            item.cartGoodses.forEach((sub, index) => {
              if (sub.cartSelected) count++;
            });
            item.Selected = count == item.cartGoodses.length ? true : false; //勾选的数量  和 当前商店的商品数量 一致  该商店勾选
            if (item.Selected == true) storenum++;
          });
          this.all = storenum == data.cartGoodsItems.length ? true : false;
          console.log("data", data);
          this.cartInfoList = data.cartGoodsItems;
          this.totalGoodsPrice = data.totalGoodsPrice;
          this.totalGoodsNum = data.totalGoodsNum;
        } else {
          this.cartInfoList = [];
          this.totalGoodsPrice = 0;
          this.totalGoodsNum = 0;
        }
      });
    },
    //13.9.获取购物车商品数量
    getCartNum() {
      this.getCartGoodsNum([]).then((res) => {
        this.CartGoodsNum = res;
      });
    },
    //选中某品牌   =>该品牌下的DIY和商品勾选
    storeAll(checked, index) {
      //当前店铺的所有商品列表
      let goods = this.cartInfoList[index].cartGoodses;
      // 检查是否勾选 index 的店铺
      let isStoreAll = checked ? true : false;
      //如果店铺选中，所属商品全部选中   反之亦然
      for (var i = 0; i <= goods.length - 1; i++) {
        goods[i].cartSelected = isStoreAll;
      }
      this.changeCheckbox();
    },
    //复选框改变事件
    changeSelect(checked, storeIndex, goodsIndex) {
      this.cartInfoList[storeIndex].cartGoodses[
        goodsIndex
      ].cartSelected = checked;
      this.changeCheckbox();
    },
    //勾选事件
    changeCheckbox() {
      let sum = 0; //金钱
      let storenum = 0; //选中的店铺数量
      this.cartInfoList.forEach(function (item) {
        let count = 0; //商品数量
        item.cartGoodses.forEach(function (sub, index) {
          if (sub.cartSelected == true) {
            count++;
            sum += sub.goodsNum * sub.salePrice;
          }
        });
        item.Selected = count == item.cartGoodses.length ? true : false;
        if (item.Selected == true) storenum++;
      });
      this.all = storenum == this.cartInfoList.length ? true : false;
      this.totalGoodsPrice = sum.toFixed(2);
    },
    //全选
    handleCheckAllChange(checked) {
      //全选按钮状态
      let isAll = checked ? true : false;
      this.all = isAll;
      //根据全选按钮 标记其他复选框
      this.cartInfoList.forEach(function (item) {
        item.Selected = isAll;
        item.cartGoodses.forEach(function (sub, index) {
          sub.cartSelected = isAll;
        });
      });
      this.changeCheckbox();
      //console.log(this.all,checked);
    },
    //商品数量修改
    changeNum(action, id, num) {
      if (action == "reduce") {
        if (num <= 1) return;
        this.api.cartHandler.decrMemCartNum([id], (res) => {
          //console.log(res)
          this.cartInfo();
        });
      } else if (action == "add") {
        this.api.cartHandler.incrMemCartNum([id], (res) => {
          this.cartInfo();
        });
      }
      this.toast.toast = true;
      this.toast.messageTip = "商品数量修改成功";
      setTimeout(() => {
        this.toast.toast = false;
      }, 1500);
    },
    // 删除
    deleteItem(id) {
      this.deleteid = id;
      this.isDelete = true;
    },
    //单个删除
    removeCart() {
      this.api.cartHandler
        .removeMemCart([this.deleteid], (res) => {
          //this.cartInfoList = [];
          this.cartInfo();
          this.toast.toast = true;
          this.toast.messageTip = "删除成功";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = "删除失败";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
      this.isDelete = false;
    },
    //批量删除
    removeCarts() {
      let _this = this;
      let delCartIds = [];
      this.cartInfoList.forEach(function (item) {
        item.cartGoodses.forEach(function (sub, index) {
          if (sub.cartSelected) {
            delCartIds.push(sub.instSkuId);
          }
        });
      });
      this.api.cartHandler
        .removeMemCarts([delCartIds], (res) => {
          //this.cartInfoList = [];
          this.cartInfo();
          this.toast.toast = true;
          this.toast.messageTip = "删除成功";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = "删除失败";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
      this.isDeletes = false;
    },
    //商品加减
    goodsNum(action) {
      if (action == "add") {
        this.goodsNumber += 1;
        this.api.cartHandler.incrMemCartNum([], (res) => {
          console.log(res);
        });
      } else if (action == "reduce") {
        if (this.goodsNumber == 0) return;
        this.goodsNumber -= 1;
      }
      this.toast.toast = true;
      this.toast.messageTip = "商品数量修改成功";
      setTimeout(() => {
        this.toast.toast = false;
      }, 1500);
    },
    // 批量加入收藏夹
    addCollect() {
      let delCartIds = [];
      this.cartInfoList.forEach(function (item) {
        item.cartGoodses.forEach(function (sub, index) {
          if (sub.cartSelected) {
            delCartIds.push(sub.instSkuId);
          }
        });
      });
      this.api.cartHandler
        .addMemFavBatchFormCart([delCartIds], (res) => {
          //console.log(res);
          //this.cartInfo();
          this.toast.toast = true;
          this.toast.messageTip = "收藏成功";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = "收藏失败";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
    },
    //点击全选
    selectAll(checked) {
      var _this = this;
      if (checked) {
        //实现反选
        _this.value = [];
        _this.cartData.forEach(function (item) {
          _this.value.push(item.id);
        });
      } else {
        //实现全选
        _this.value = [];
      }
    },
    // 初始化店铺结算信息
    initSettleDatas(OrderSettleMsg) {
      let _this = this;
      let settleDatas = [];
      let couponAmounts = [];
      let redpacketAmounts = [];
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用优惠券",
            couponAmount: 0,
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用红包",
            couponAmount: 0,
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        let instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function (sub) {
          //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });

        settleDatas.push({
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId: "0",
          remark: "",
          dealerCode: "",
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0);
        redpacketAmounts.push(0);
      });
      let orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      storage.local.set("orderData", orderData);
    },
    goOrderPay() {
      let selectCartIds = [];
      let _this = this;
      this.cartInfoList.forEach(function (item) {
        item.cartGoodses.forEach(function (sub) {
          if (sub.cartSelected) {
            selectCartIds.push(sub.instSkuId);
          }
        });
      });
      if (selectCartIds.length < 1) {
        //this.$message.warning("请选择要结算的商品!");
        return false;
      }
      this.getOrderSettleMsgFromCart([selectCartIds])
        .then((res) => {
          this.initSettleDatas(res); // 初始化店铺结算信息

          this.$router.push({
            path: "/main/firmorder",
          });
        })
        .catch((err) => {
          this.toast.toast = true;
          this.toast.messageTip = "结算失败，等会再试试吧~";
          setTimeout(() => {
            this.toast.toast = false;
          }, 1500);
        });
    },
  },
  components: {
    menus,
    emptyCart,
    touchDelete,
    imgs,
  },
  mounted() {},
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
@import "src/views/personal/personal.scss";
.cart-wrap {
  .cartBottom .pdl {
    padding-left: 0.5rem;
  }
  /*顶部title*/
  .grid-tip {
    height: 1rem;
    line-height: 1rem;
    background: #fff;
    padding: 0 0.35rem;
    margin-bottom: 1px;
    @include font-dpr(14px);
    p {
      float: right;
    }
  }
  .cart-box {
    .cart-list {
      hr {
        -webkit-margin-before: 0em;
        -webkit-margin-after: 0em;
        margin-left: 1.3rem;
        /*background: #e5e5e5;*/
        border: none;
        @include bdT(#e5e5e5, top);
        height: 1px;
        background-image: linear-gradient(0deg, transparent 50%, #e5e5e5);
        /*border-top:1px solid #e5e5e5;*/
      }
      .cart-item:last-child {
        margin-bottom: 0;
      }
      .cart-item {
        margin-bottom: 0.2rem;
        border-bottom: 1px solid #ccc;
        /*品牌标题*/
        .brandTitle {
          padding: 0 0.4rem;
          height: 1rem;
          line-height: 1rem;
          background: #fff;

          @include bdT(#e5e5e5, bottom);
          .list-radio {
            min-width: 0.5rem;
            height: 0.5rem;
            margin-top: 0.25rem;
            margin-right: 0.4rem;
          }
          .logo {
            margin-right: 0.2rem;
            width: auto;
            img {
              height: auto;
              width: 100%;
              max-height: 1rem;
              max-width: 1.5rem;
            }
          }
          p {
            float: left;
            margin-right: 0.2rem;
            color: #2a2a2a;
            label {
              color: #999999;
            }
          }
          .user-right {
            height: 0.3rem;
          }
          .getcoupon {
            float: right;
            @include font-dpr(14px);
            color: #4a4a4a;
          }
        }
        /*列表*/
        .mu-list.isedit {
          .mu-item-title-row {
            display: none;
          }
          .deleteIcon {
            display: none;
          }
          .move {
            transform: translateX(0rem) !important;
          }
        }
        .mu-list {
          padding: 0;
          overflow-y: hidden;
          .leftAvataDiv {
            width: 100%;
            height: 100%;
          }
          .list-radio {
            position: absolute;
            left: 0.4rem;
            top: 1.2rem;
          }
          .mu-item {
            background: #fff;
            height: 2.8rem;
            padding: 0.4rem;
            padding-left: 3.5rem;
            /*border-top: 1px solid #e5e5e5;*/
            /*margin-bottom: 0.2rem;*/
            .mu-item-left,
            .mu-item-right {
              width: 2rem;
              max-height: 2.5rem;
              left: 1.3rem;
              height: initial;
              top: initial;
              .mu-avatar {
                width: 2rem;
                height: 2rem;
                img {
                  border-radius: 0px;
                }
              }
            }
          }
          .mu-item-content {
            align-self: unset;
            .mu-item-title-row {
              .mu-item-title {
                @include font-dpr(13px);
                line-height: 1.2;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }

            .mu-item-text-my {
              @include font-dpr(12px);
              line-height: 1.5;
              color: #999999;
              margin-top: 0.1rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            /*列表价格  加减*/
            .listItem {
              line-height: 1;
              margin-top: 0.1rem;
              text-align: center;

              .price {
                float: left;
                @include font-dpr(16px);
                color: #e60012;
                position: absolute;
                bottom: 0.4rem;
                label {
                  color: #999;
                  text-decoration: line-through;
                  @include font-dpr(12px);
                  margin-left: 0.2rem;
                }
              }
              .count {
                margin-top: 0.1rem;
                float: right;
                @include font-dpr(12px);
                color: #999999;
                position: absolute;
                bottom: 0.4rem;
                right: 0.4rem;
              }
            }
            .listItem.edit {
              margin-bottom: 0.2rem;
              > input,
              > span {
                display: inline-block;
                border-radius: 0.1rem;
                vertical-align: middle;
              }
              > span {
                width: 1.5rem;
                height: 0.5rem;
                &.add-btn {
                  float: left;
                  background: url(/static/images/detail_product_delete_3x.png)
                    no-repeat center;
                  background-size: 0.35rem auto;
                }
                &.reduce-btn {
                  float: right;
                  background: url(/static/images/detail_product_add_3x.png)
                    no-repeat center;
                  background-size: 0.35rem auto;
                }
              }
              .input {
                width: 1.75rem;
                margin: 0 6px;
                text-align: center;
                @include font-dpr(16px);
                color: #000000;
              }
            }
            /*样式选项按钮*/
            .arrow-expand {
              width: 0.5rem;
              height: 0.5rem;
              background: url(/static/images/product_arrow_expand@3x.png)
                no-repeat center;
              background-size: 0.45rem auto;
              margin-top: 0.15rem;
              position: absolute;
              right: 0.4rem;
            }
          }
        }
        /*DIY  购物车左侧线条*/
        .dashLine {
          position: absolute;
          left: 0.6rem;
          border-left: 1px dashed #c2c2c2;
          width: 1px;
        }
        /*标题栏*/
        .dashLineparent {
          height: 1rem;
          bottom: 0px;
          z-index: 99;
        }
        /*最后一条只有 上方 有*/
        .dashLinetop {
          height: 0.4rem;
          top: 0px;
        }
        .dashLineall {
          height: 2.8rem;
          top: 0px;
        }
        .pointp {
          width: 0.2rem;
          height: 0.2rem;
          position: absolute;
          left: 0.52rem;
          top: 0.4rem;
          border-radius: 60%;
          background: #d8d8d8;
        }
        /*DIY*/
        .cartTitle {
          position: relative;
          .mu-list {
            .list-radio {
              position: absolute;
              left: 0.4rem;
              top: 0.75rem;
            }
            .mu-item {
              background: #fff;
              height: 2.3rem;
              padding: 0.4rem;
              padding-left: 1.2rem;
            }
            .mu-item-content {
              .listItem.edit {
                margin: 0.2rem 0 0 0.1rem;
              }
            }
          }
        }
      }
    }
  }
}

.custom-popup-bottom {
  width: 100%;
  height: 9.25rem;
  background: #fff;
  font-size: 0;
  .flex-item {
    padding: 0.2rem 0.35rem;
    .goods-detail {
      position: relative;
      padding-bottom: 0.2rem;
      @include bdT(#dfdfdf, bottom);
      .close-button {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0;
        right: 0;
        background: url(/static/images/dialog_cancel_3x.png) no-repeat center;
        background-size: cover;
        z-index: 5;
      }
      .goods-img {
        display: inline-block;
        width: 2.1rem;
      }
      .goods-desc {
        position: absolute;
        top: 0;
        right: 0;
        left: 2.575rem;
        @include font-dpr(14px);
        .price {
          padding: 0.2rem 0;
          @include font-dpr(20px);
          color: #e60012;
          > samp {
            @include font-dpr(13px);
            padding-right: 0.125rem;
          }
        }
        .desc {
          color: #444444;
          line-height: 1.4;
        }
      }
    }
    .title {
      padding: 0.1rem 0 0.25rem 0;
      @include font-dpr(14px);
      color: #666666;
    }
    .goods-label {
      padding: 0.15rem 0;
      @include bdT(#dfdfdf, bottom);
      .label-list {
        .label {
          @include font-dpr(14px);
          display: inline-block;
          line-height: 1;
          margin: 0 0.225rem 0.15rem 0;
          padding: 0.175rem 0.3rem;
          border: 1px solid #b9b9b9;
          color: #444444;
          border-radius: 0.1rem;
          &.active {
            border-color: #d0021b;
          }
        }
      }
    }
    .goods-number {
      padding: 0.225rem 0;
      > input,
      > span {
        display: inline-block;
        height: 0.875rem;
        border: 1px solid #cfcfcf;
        border-radius: 0.1rem;
        vertical-align: middle;
      }
      > span {
        width: 0.875rem;
        &.add-btn {
          background: url(/static/images/detail_product_delete_3x.png) no-repeat
            center;
          background-size: 0.35rem auto;
        }
        &.reduce-btn {
          background: url(/static/images/detail_product_add_3x.png) no-repeat
            center;
          background-size: 0.35rem auto;
        }
      }
      > input {
        width: 1.75rem;
        margin: 0 6px;
        text-align: center;
        @include font-dpr(16px);
        color: #000000;
      }
      > samp {
        display: inline-block;
        margin-left: 0.4rem;
        @include font-dpr(14px);
        color: #666666;
        vertical-align: middle;
      }
    }
  }
  .mu-raised-button {
    display: inline-block;
    width: 50%;
    border: 0px solid;
    box-shadow: none;
    border-radius: 0;
    vertical-align: top;
    min-width: auto;
    height: 1.25rem;
    color: #fff;
    @include font-dpr(16px);
    &.add-cart {
      background: #ff910e;
    }
    &.buyNow {
      background: #e60012;
    }
    &.fullButton {
      width: 100%;
      background-image: linear-gradient(-90deg, #ff4901 0%, #ff7701 100%);
    }
  }
}
.coupon-receive-popup-bottom {
  width: 100%;
  height: 9.25rem;
  background: #fff;
  font-size: 0;
  .empty-wrap {
    height: 4rem;
    position: relative;
    .empty-box {
      margin-top: 0px;
    }
  }
  .flex-item {
    padding: 0.2rem 0.35rem;
    .goods-detail {
      position: relative;
      padding-bottom: 0.2rem;
      .close-button {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0;
        right: 0;
        background: url(/static/images/dialog_cancel_3x.png) no-repeat center;
        background-size: cover;
        z-index: 5;
      }
      .coupon-box {
        .coupon-list {
          .coupon-list-item.title {
            text-align: center;
            @include font-dpr(18px);
            color: #333333;
            @include bdT(rgba(255, 255, 255, 0), bottom);
            margin-bottom: 0rem;
          }
          .coupon-list-item {
            width: 100%;
            @include font-dpr(14px);
            color: #333333;
            padding: 0.35rem 0;
            margin-bottom: 0.2rem;
            tr {
              height: 1.6rem;

              border-bottom: 1px solid #efefef;
            }
            .redpackage {
              background: url(/static/images/red_packet_bg_3x.png) no-repeat
                center;
              height: 1.125rem;
              background-size: 80% 1rem;
              color: #fff;
              /*margin-right: 0.2rem;*/
              line-height: 1.2rem;
              text-align: center;
            }
            .coupon {
              background: url(/static/images/personal_coupon_3x.png) no-repeat
                center;
              height: 1.125rem;
              background-size: 80% 1rem;
              color: #fff;
              /*margin-right: 0.2rem;*/
              line-height: 1.2rem;
              text-align: center;
            }
            p {
              color: #666666;
              line-height: 1.5;
            }
            label {
              @include font-dpr(12px);
              color: #999;
              line-height: 1;
            }
            .gray {
              @include font-dpr(12px);
              float: right;
              background: #fff;
              border: 1px solid #a5a5a5;
              color: #333;
              width: auto;
              padding: 0 0.1rem;
              height: 1rem;
              max-height: 0.8rem;
              border-radius: 5px;
              .mu-raised-button-label {
                padding: 0;
              }
            }
            .gray.finish {
              border: 1px solid #e2e2e2;
              color: #dadada;
            }
          }
        }
      }
    }
  }
  .mu-raised-button {
    display: inline-block;
    width: 50%;
    border: 0px solid;
    box-shadow: none;
    border-radius: 0;
    vertical-align: top;
    min-width: auto;
    height: 1.25rem;
    color: #fff;
    @include font-dpr(16px);

    &.fullButton {
      width: 100%;
      background-image: linear-gradient(-90deg, #ff4901 0%, #ff7701 100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// cart.vue?bb5e771c